import { Box, Button, Checkbox, FormControlLabel, FormGroup, Paper, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useState } from "react";
import appConfig from "src/config/env";
import { COMMOM_STATUS, EXPORT_TYPE, EXPORT_TYPE_TRANSLATETRANSLATE, PRINT_SIZE } from "src/constant";
import useOrderPrint from "src/hooks/orders/useOrderPrint";
import useProcessLogDetail from "src/hooks/process-log/useProcessLogDetail";
import useQueryParams from "src/hooks/useQueryParams";
const status = {
  createOrderBill: "createOrderBill",
  prepare: "prepare",
};
const outputFiles = [EXPORT_TYPE.PickingList, EXPORT_TYPE.DeliveredReceipt, EXPORT_TYPE.WarehouseExport];
export default function DAPrint({ total, warehouseId, setTotal }) {
  const [option] = useQueryParams();
  const [outputType, setOutputType] = useState([]);
  const [logId, setLogId] = useState();
  const { trigger: printAll } = useOrderPrint();
  const { mutate } = useProcessLogDetail(logId, {
    warehouse: warehouseId,
  });

  const handlePrintAllOrders = async () => {
    const res = await printAll({
      body: {
        orderIds: total,
        pageSize: PRINT_SIZE.a6,
        warehouse: warehouseId,
        outputFiles: outputType,
      },
    });
    if (res?.success) {
      handleGetLog(res?.data?._id);
      setLogId(res?.data?._id);
      return enqueueSnackbar("Tiến hành xuất phiếu...", { variant: "success", className: 'notistack-confirm' });
    } else {
      return enqueueSnackbar(res?.error?.message ?? res?.error?.message, {
        variant: "error",
      });
    }
  };

  const handleGetType = (e) => {
    const value = e.target.value;
    if (outputType?.includes(value)) {
      setOutputType((prev) => [...prev.filter((v) => v !== value)]);
    } else {
      setOutputType((prev) => [...prev, value]);
    }
  };

  const handleGetLog = (logIdParam) => {
    const logIdToUse = logIdParam || logId;
    if (!logIdToUse) return;
    const timeOut = setInterval(async () => {
      try {
        const res = await mutate();
        if (res?.success) {
          if (res.data.status === COMMOM_STATUS.done) {
            if (Array.isArray(res.data?.urls)) {
              res.data.urls.forEach((v) => {
                window.open(`${appConfig.API_FILE}/${v}`, "_blank");
              });
            }
            setTotal([]);
            setOutputType([]);
            clearInterval(timeOut);
          }

          if (res.data.status === COMMOM_STATUS.error) {
            enqueueSnackbar("Không xuất được đơn", { variant: "error" });
            clearInterval(timeOut);
          }
        }
      } catch (err) {
        clearInterval(timeOut);
      }
    }, 1000);
  };

  return (
    <Paper sx={{ p: "12px" }}>
      <Typography
        variant="body1"
        fontWeight="bold"
        mb="10px"
      >
        Tạo phiếu hàng loạt
      </Typography>

      <Typography
        variant="body2"
        mb="18px"
      >
        <strong>({total?.length ?? 0})</strong> Đơn hàng được chọn
      </Typography>

      {option?.child === status.createOrderBill && (
        <>
          <FormGroup>
            {outputFiles.map((v) => {
              return (
                <FormControlLabel
                  key={v}
                  value={v}
                  checked={outputType.includes(v)}
                  onChange={handleGetType}
                  control={<Checkbox />}
                  label={EXPORT_TYPE_TRANSLATETRANSLATE[v]}
                />
              );
            })}
          </FormGroup>
          <Button
            disabled={total?.length === 0 || outputType.length === 0}
            onClick={handlePrintAllOrders}
            sx={{ mt: "12px" }}
            fullWidth
            variant="contained"
          >
            Tạo phiếu
          </Button>
        </>
      )}
    </Paper>
  );
}
